


<template>

  <div>



<v-card flat v-show="!this.$store.state.H5P.isVideoReady && this.$store.state.currentEditTab == 'quiz_tab'">



    <v-progress-linear
      indeterminate
      color="green"
    ></v-progress-linear>

    <v-card-text> Initializing Shuttle... </v-card-text>

</v-card>



<div v-show="this.$store.state.H5P.isVideoReady && this.$store.state.currentEditTab == 'quiz_tab'">
  <v-card flat >

    <v-toolbar flat>
            <v-toolbar-title>Current Quizzes</v-toolbar-title>


            <v-spacer></v-spacer>


         <v-btn outlined small color="primary" @click="createNewQuiz();">
          <v-icon left>mdi-plus-circle-outline</v-icon>
         Create New Quiz
        </v-btn>  

        <!-- @click="newBookmark()" -->
        <v-btn outlined small color="primary" @click="addQuiz()">
         + Add Quiz
        </v-btn>

        </v-toolbar>


      </v-card>



        <v-card class="mr-6 ml-6" v-if="display_form">
          <v-card-subtitle class="font-weight-bold">ADD Quiz to Shuttle</v-card-subtitle>

          <v-card-text>

          <v-select
          v-model="selected_quiz"
          :items="quizzes.quizzes"
          chips
          label="Select a Quiz to Add"
          return-object

          item-text="title"
          item-value="id"
          dense
          >

          </v-select>

       <v-text-field

                                        
          v-model="currentQuiz.action.params.displayTime"
          label="Launch Quiz at (MM:SS)"
          outlined

        ></v-text-field>



      <v-checkbox
      v-model="currentQuiz.action.params.required"
      :label="`Required. The learner must attempt this quiz: ${currentQuiz.action.params.required.toString()}`"
      ></v-checkbox>


      <v-checkbox
      v-model="currentQuiz.action.params.scored"
      :label="`Scored. This quiz is scored and can be used for completion logic: ${currentQuiz.action.params.scored.toString()}`"
      ></v-checkbox>



       <v-text-field

                                        
          v-model="currentQuiz.action.params.passingScore"
          label="Passing Score %"
          outlined

        ></v-text-field>

       <v-text-field

                                        
          v-model="currentQuiz.action.params.maxAttempts"
          label="Maximum Attempts (0=unlimmited)"
          outlined

        ></v-text-field>
          </v-card-text>

          <div class="text-right">
            <v-btn width="100" small outlined text color="primary" class="mx-4 mb-4" @click="closeFormDisplay()">
              Cancel
            </v-btn>
            <v-btn width="100" small color="primary" class="mx-4 mb-4" @click="saveInteraction()" >
              Save
            </v-btn>
          </div>

        </v-card>





<v-card flat >




<v-row class="pa-0 ma-0">

<v-col cols="12" md="12" sm="12">

  <v-data-iterator
  
    :items="interactionList"
    hide-default-footer
    no-data-text="Click the '+ ADD' button above to add your first quiz to this shuttle. You can create a new quiz by clicking on Create New Quiz.  Quizzes can be used on multiple shuttles."
  >



<template v-slot:header>
</template>

<template v-slot:default="props">
  <v-container fluid>
    <v-row>
        <v-col
          v-for="item in props.items"
          :key="item.id"
          cols="12"
          sm="12"
          md="12"
        >
          <v-card>

            <v-row>
              <v-col cols="2">
                <v-img width="80" height="80" contain :src="item.action.params.surveyJS.logo"></v-img>



              </v-col>

              <v-col cols="8">
                <div class="subheading font-weight-bold">{{ item.action.params.surveyJS.title }}</div>
                <div>{{ fmtMSS(item.duration.from) }}</div>
              </v-col>

              <v-col cols="2">
                <v-btn icon   @click="editItem(item)">
                  <v-icon


                  >
                    mdi-pencil
                  </v-icon>
                </v-btn>


                <v-btn icon @click="deleteItem(item)">
                  <v-icon



                  >
                    mdi-delete-forever-outline
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>

          </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>






</v-data-iterator>

</v-col>
</v-row>
</v-card>

</div>


</div>

</template>





<script>
	import { v4 as uuidv4 } from 'uuid';
	import { mapGetters } from 'vuex'
  import QuizMixins from '@/mixins/QuizMixins.js';
  import ShuttleMixins from '@/mixins/ShuttleMixins.js';

export default {
  name: 'ShuttleQuizInteractions',
   mixins:[ShuttleMixins,QuizMixins],
    data() {
    	return {
          
          interactionList:[],
          quizzes:{},
          display_form:false,
          selected_quiz:{},


          quiz_template:{
                  libraryTitle: 'SurveyJS',
                  label: '',
                  pause: true,
                  maxScore:0,
                  duration: {
                    from: 0,
                    to: 0
                  },
                  buttonOnMobile: false,
                  displayType: 'poster',
                  x: 0,
                  width: 100,
                  y: 0,
                  action: {
                    params:{

                      id:"0000-0000-0001",
                      required:false,
                      scored:false,
                      passingScore:75,
                      maxAttempts:0,
                      maxScore:0,
                      displayTime:'0:00',

                      surveyJS:{}


                    },
                    subContentId: '15bd67c5-bb55-4475-9b03-e0879d74476d',
                    library: 'H5P.SurveyJS 1.0'
                  },
                  id: '',
                  height: 50
                },


            



    	}
	},


props:{

	tabupdate:Number
},
watch:{

	tabupdate(){

		this.init();

	},

  selected_quiz(){

      this.currentQuiz.action.params.id = this.selected_quiz.id;

  }

},




created(){

      var vm = this;
      this.unsubscribe =this.$store.subscribe((mutation, state) => {
            

          ////console.log('QUIZ MUTATIONS ACTIVE TAB: ' + this.$store.state.currentEditTab)

            if (mutation.type === 'currentShuttleQuizInteractions'){
                vm.reloadQuizEditor()

            }



              if( mutation.type === 'H5P' && this.$store.state.currentEditTab == 'quiz_tab'){
                // //console.log('transcript mutation: ' + mutation.type )
                
                this.setTimeUpdateListener();

              }


          });

 },
  beforeDestroy() {
    this.unsubscribe();
  },


	mounted(){
			this.init()
	},

	 methods: {


          async reloadQuizEditor(){

               var x = await vm.init();
              var y = await vm.updateInteractionDisplay();

          },

          async updateInteractionDisplay(){

             var vm = this;

                if(vm.$store.state.currentShuttle.quizInteractions){
                    vm.interactionList =vm.$store.state.currentShuttle.quizInteractions;
                    //this.setInteractionsDraggable();
            } else {

                vm.interactionList = [];
            }



          },


	 		async init(){

          this.getQuizInteractions();
          this.quizzes = await this.getUserQuizzes();
          
          

	 		},

      addQuiz(){

            this.currentQuiz = this.quiz_template;
            this.currentQuiz.id =uuidv4(); //unique id for this interaction

            //vue does not update items tied to subobjects.. fun times.

            this.currentQuiz.action.params.displayTime = this.quiz_template.action.params.displayTime;
            this.currentQuiz.action.params.required = this.quiz_template.action.params.required;
            this.currentQuiz.action.params.scored = this.quiz_template.action.params.scored;
            this.currentQuiz.action.params.passingScore = this.quiz_template.action.params.passingScore;
            this.currentQuiz.action.params.maxAttempts  = this.quiz_template.action.params.maxAttempts;
            this.selected_quiz = {};
            this.displayForm();



      },



editItem(item){

 this.currentQuiz = item;
  var q = this.quizzes.quizzes.find(({id}) => id == this.currentQuiz.action.params.id);
  this.selected_quiz = q;



  //console.log(item);
  this.seekCurrentVideo(item.duration.from);

  this.display_form = true;


},

deleteItem(item){
  this.currentQuiz = item;


  //let deteleInteraction = this.$store.state.currentShuttle.textInteractions.find(({id}) => id == this.diplay_actionId);

  this.interactionList = this.interactionList.filter(x => {
      return x.id != this.currentQuiz.id;
    });


  this.$store.commit('currentShuttleQuizInteractions',this.interactionList);
    this.saveShuttle();

},


saveInteraction(){


        this.currentQuiz.duration.from = this.hmsToSecondsOnly(this.currentQuiz.action.params.displayTime);

        this.currentQuiz.duration.to = this.hmsToSecondsOnly(this.currentQuiz.action.params.displayTime);



        var q = this.quizzes.quizzes.find(({id}) => id == this.currentQuiz.action.params.id);

        this.currentQuiz.action.params.surveyJS = q.SurveyJS;
        ////console.log(JSON.stringify(q.SurveyJS))

        //overrides for format in shuttle

        //in shuttle we do one question per page. so reformat
        var maxScore = 0;
        var formatPages = [];


          if(q.SurveyJS.pages[0].elements){
          for (var question of q.SurveyJS.pages[0].elements){

            var page = {
              questions:[]
            }
            //var formatQuestion = {questions:[]};
            page.questions.push(question);
            maxScore = maxScore + 1
            formatPages.push(page)

          }
        }


          if(q.SurveyJS.pages[0].questions){
          for (var question of q.SurveyJS.pages[0].questions){

            var page = {
              questions:[]
            }
            //var formatQuestion = {questions:[]};
            page.questions.push(question);
            maxScore = maxScore + 1
            formatPages.push(page)

          }
        }






        //console.log(formatPages);
        this.currentQuiz.action.params.surveyJS.pages = formatPages;


        this.currentQuiz.action.params.maxScore = maxScore;
        this.currentQuiz.maxScore = maxScore;

        this.currentQuiz.action.params.surveyJS.showProgressBar='bottom';
        this.currentQuiz.action.params.surveyJS.firstPageIsStarted=true;
        this.currentQuiz.action.params.surveyJS.startSurveyText= "Start Quiz";


        //console.log(this.currentQuiz);
 

       
      if(this.$store.state.currentShuttle.quizInteractions){
                    let updateInteraction = this.$store.state.currentShuttle.quizInteractions.find(({id}) => id == this.currentQuiz.id);

                        if(updateInteraction){

                            updateInteraction = this.currentQuiz;
                        } else {

                            this.interactionList.push(this.currentQuiz);

                        }
                } else {

                    this.interactionList.push(this.currentQuiz);
                }
        this.$store.commit('currentShuttleQuizInteractions',this.interactionList);
                this.saveShuttle();
           


        },




      closeFormDisplay(){
        this.display_form = false;

      },

      displayForm() {
        this.display_form = true;
        //this.newInteraction();
      },

      hasQuizzes(){

          if(this.quizzes.hasOwnPropert('quizzes')){

              if (this.quizzes.quizzes.length > 0){
                return true;
              }
          }

          return false;

      },


          async getQuizInteractions(){

             var vm = this;

                if(this.$store.state.currentShuttle.quizInteractions){
                    this.interactionList = this.$store.state.currentShuttle.quizInteractions;
                    //this.setInteractionsDraggable();
            } else {

                this.interactionList = [];
            }


          },

    setTimeUpdateListener(){
        ////console.log('time update LISTENER')
        var vm = this;
           this.H5PObject = H5P.instances[0];
          //H5PObject.video.off('videoTimeUpdate',function(e){vm.setQuizTime(e.data)});
          this.H5PObject.video.on('videoTimeUpdate',function(e){vm.setQuizTime(e.data)});
    },



    setQuizTime(timestamp){


      if(this.currentQuiz.action){
        this.currentQuiz.action.params.displayTime = this.fmtMSS(timestamp);
      }
    },


	 }//end methods

}

           
</script>


